<mat-form-field
	[color]="color"
	[appearance]="appearance"
	[floatLabel]="floatLabel"
	[ngClass]="{
		hasError: __hasError
	}"
>
	<mat-label
		[innerHtml]="label"
		[ngClass]="{
			'label-error': __hasError
		}"
	></mat-label>
	<input
		matInput
		[formControl]="_control"
		[placeholder]="placeholder"
		[required]="required"
		type="number"
		[step]="step"
		[attr.min]="minValue"
		[attr.max]="maxValue"
	/>
	<mat-hint [innerHtml]="hint ? hint : ''"></mat-hint>
	<mat-error [innerHtml]="error"></mat-error>
	<img *ngIf="showImage" class="valid-tick" [src]="imageUrl" />
</mat-form-field>
